import React, { useState } from "react";

import {DropzoneArea} from 'material-ui-dropzone'

import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import  api from './api';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Link from '@material-ui/core/Link';
import axios from "axios";
import { Button } from "@material-ui/core";

const Media = ({
  module,
  onChange,
  disabled,
  media,
  title,
  acceptedFiles,
  qAcceptedFiles,
  onRefresh,
  showDelete,
  ...props
}) => {

  const [modal, setModal] = useState({})
  const handleChange = (files) => {
  	onChange(files)
  }

  const handleDeleteMedia = (id) => {
	const token = localStorage.getItem('userToken')
	axios.delete(api.media().delete(id),{ headers: {"Authorization" : `Bearer ${token}`}},
	 {params: {'media[id]':id }}
	  )
	  .then((response)=> {
			setModal({open: true, message:"Adjunto eliminado con éxito", severity: "success"})
			onRefresh()
		})
	  .catch(function (error) {
		setModal({open: true, message:"No pudo borrarse el adjunto. Por favor contacte a su administrador", severity: "success"})
	})
  }  
  return (
  	<div>
	<Typography variant="h6" className="mt-2"	>
		{title || 'Archivos adjuntos'}
	</Typography>

    {(disabled===false)? (
		<div style={{width: "30rem"}}>
			<DropzoneArea onChange={(e)=>handleChange(e)} 
				dropzoneText="Arrastra los archivos aquí o buscalos"
				showPreviews="true"
				showPreviewsInDropzone={false}
				showFileNamesInPreview="true"
				filesLimit={qAcceptedFiles}
				showFileNames="true"
				className="mb-2"
				acceptedFiles={acceptedFiles ? acceptedFiles : []}
			/>
		</div>
		)
	:
		''
	}

    <div className="row"></div>
    {(media.length>0)?(
	    <Table aria-label="simple table">
	        <TableHead>
	          <TableRow>
	            <TableCell>Nombre del archivo</TableCell>
	            <TableCell colSpan={2}></TableCell>
	          </TableRow>
	        </TableHead>
	        <TableBody>
	          {media.map((val,idx) => (
	            <TableRow key={val.id}>
	              <TableCell>{val.name}</TableCell>
	              <TableCell>
	              	<Link href={api.media_download+'/'+val.id}><ArrowDownwardIcon />Descargar</Link>
	              </TableCell>
				  <TableCell>
					{showDelete && <Button onClick={() => {handleDeleteMedia(val.id)}}>Eliminar adjunto</Button>}
				  </TableCell>
	            </TableRow>
	          ))}
	        </TableBody>
	      </Table>
        )
    	:''
      }
      </div>
	)

}

Media.defaultProps = {
  media: [],
  disabled: false,
  showDelete: false,
  qAcceptedFiles: 3
}

export default Media;
